import React from 'react';
import clsx from 'clsx';
import styles from 'components/common/common.module.scss';

type Props = {
  id?: string;
  children?: React.ReactNode;
  className?: string;
  required?: boolean;
};

function Label({
  children, required, className, id = 'label',
}: Props) {
  const classes = clsx(styles.inputTextLabel, className);
  return (
    <label
      htmlFor={id}
      className={classes}
    >
      {children}
      {required && <sup className="text-red-500 !absolute !text-lg top-1">*</sup>}
    </label>
  );
}

export default Label;
